"use strict";
angular.module("timeSlotSelectModule", ['singleSelectTimeModule']).directive("timeSlotSelect", function($filter) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            beginTime: '=',
            endTime: '=',
            curTime: "="
        },
        templateUrl: './planningCenter/hotFocus/directive/timeSlotSelect/timeSlotSelect_tpl.html',
        link: function(scope, $elem, $attrs) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {

                scope.status = {
                    selectedBeginTime: {
                        name: '开始时间',
                        value: -1
                    },
                    selectEndTime: {
                        name: '结束时间',
                        value: -1
                    },
                    beginTimeList: [],
                    endTimeList: [],
                    isActive: false, // 
                }

            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {

            }

            scope.$watch("curTime", function(newV, oldV) {
                if (newV) {
                    initTimeData();
                }
            });

            scope.$watch("status.selectedBeginTime", function(newV, oldV) { //监控是否切换到其他模块
                if (angular.isUndefined(scope.status.selectedBeginTime)) return;
                if (newV.value != -1) {
                    initTimeData(newV);
                }
            });

            scope.$watch("status.selectEndTime", function(newV, oldV) { //监控是否切换到其他模块
                if (angular.isUndefined(scope.status.selectEndTime)) return;
                if (newV.value != -1) {
                    initTimeData(newV);
                }
            });

            function initTimeData(breakVal) {
                // if (scope.curTime) {
                //     scope.status.curHour = scope.curTime;
                // } else {
                //     scope.status.curHour = $filter("date")(Date.parse(new Date()), "HH");
                // }
                scope.status.endTimeList = [];
                scope.status.beginTimeList = [];

                let hourNum = Number(scope.curTime);

                if (angular.isUndefined(breakVal)) { //无分界点，初始化下拉树
                    for (let i = hourNum; i >= 0; i--) {
                        let name = i < 10 ? ('0' + i + ':00') : (i + ':00');
                        scope.status.endTimeList.unshift({
                            name: name,
                            value: i,
                            type: '0'
                        })
                        if (i == hourNum) { continue; } // 如果i 等于 当前小时点时，不插入beginTimeList
                        scope.status.beginTimeList.unshift({
                            name: name,
                            value: i,
                            type: '1'
                        })
                    }
                }

                if (breakVal && breakVal.type === '1') {
                    for (let i = hourNum; i >= 0; i--) {
                        let name = i < 10 ? ('0' + i + ':00') : (i + ':00');
                        if (i <= breakVal.value) {
                            scope.status.beginTimeList.unshift({
                                name: name,
                                value: i,
                                type: '1'
                            })
                        } else {
                            scope.status.endTimeList.unshift({
                                name: name,
                                value: i,
                                type: '0'
                            })
                        }

                    }
                }

                if (breakVal && breakVal.type === '0') {
                    for (let i = hourNum; i >= 0; i--) {
                        let name = i < 10 ? ('0' + i + ':00') : (i + ':00');
                        if (i < breakVal.value) {
                            scope.status.beginTimeList.unshift({
                                name: name,
                                value: i,
                                type: '1'
                            })
                        } else {
                            scope.status.endTimeList.unshift({
                                name: name,
                                value: i,
                                type: '0'
                            })
                        }

                    }
                }

            }
            /**
             * [resetBeginCallback description]开始时间段回调
             * @return {[type]} [description]
             */
            scope.resetBeginCallback = function() {
                scope.status.selectedBeginTime = {
                    name: '开始时间',
                    value: -1
                }
                scope.beginTime= '';
                if (scope.status.selectEndTime.value != '-1') {
                    initTimeData(scope.status.selectEndTime);
                } else {
                    initTimeData();
                }
            }

            /**
             * [resetBeginCallback description]结束时间段回调
             * @return {[type]} [description]
             */
            scope.resetEndCallback = function() {
                scope.status.selectEndTime = {
                    name: '结束时间',
                    value: -1
                }
                scope.endTime = '';
                if (scope.status.selectedBeginTime.value != '-1') {
                    initTimeData(scope.status.selectedBeginTime);
                } else {
                    initTimeData();
                }
            }

            scope.selectCallback = function() {
                scope.beginTime = scope.status.selectedBeginTime.value >= 0 ? scope.status.selectedBeginTime : '';
                scope.endTime = scope.status.selectEndTime.value >= 0 ? scope.status.selectEndTime : '';
            }

        }
    };
});